<style scoped>
	#app {
		padding: 20px;
	}
	.header {
		line-height: 60px;
		font-size: 16px;
		font-weight: bold;
		
	}
	.table-box {
		margin-top: 10px;
		background-color: white;
		width: 100%;
		border-radius: 3px;
		border:solid 1px #ECECEC;
	}
	
	.table-header {
		padding: 15px 20px;
		font-size: 14px;
		font-weight: bold;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
	
	.box {
		background-color: white;
		width: 100%;
		border-radius: 3px;
		border:solid 1px #ECECEC;
		display: flex;
		flex-wrap: wrap;
		padding: 10px 0;
		font-size: 14px;
	}
	.form-item {
		height: 60px;
		width: 380px;
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	.form-name {
		width: 120px;
		text-align: right;
	}
	.inp {
		width: 280px;
	}
	.el-button--primary {
		background-color: #1677FF!important;
	}
	.dot {
		color: #52C51A;
		padding: 10px;
	}
	.il {
		display: flex;
		flex-direction: row;
	}
	.t-box {
		border: solid 1px #dcdcdc;
		padding: 0 4px;
		border-radius: 4px;
	}
	.t-box1 {
		border: solid 1px #3da113;
		color: #3da113;
		padding: 0 4px;
		border-radius: 4px;
		background-color: #F7FFFE;
	}
	.t-edit {
		font-size: 14px;
		padding: 0 4px;
		margin-left: 10px;
		cursor: pointer;
	}
	.t-a {
		color: #1677FF;
		text-decoration: underline;
		cursor: pointer;
	}
</style>
<template>
	<div id="app">
		<el-breadcrumb class="nav" separator="/" style="margin-bottom: 13px;">
			<el-breadcrumb-item>系统设置</el-breadcrumb-item>
			<el-breadcrumb-item>客服设置</el-breadcrumb-item>
		</el-breadcrumb>
		
		<div class="box">
			<div class="form-item">
				<div style="width: 180px; margin-left: 20px;">
					<el-button size="medium" type="primary" @click="getData()">刷新</el-button>
				<el-button size="medium" type="danger" @click="addFunc">添加客服</el-button>
				</div>
			</div>
		</div>
		
		<div class="table-box">
			<el-table :data="tableData" border 
				v-loading="loading"
				element-loading-text="拼命加载中"
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.8)" >
			    <el-table-column prop="id" label="序号" align="center"></el-table-column>
				
				<el-table-column prop="name" label="App名称" align="center">
				</el-table-column>
				<el-table-column prop="account" label="账号" align="center">
				</el-table-column>
				<el-table-column prop="sorts" label="排序" align="center">
				</el-table-column>
				<el-table-column prop="add_time" label="添加时间" align="center">
				</el-table-column>
				
				<el-table-column prop="status" label="操作" fixed="right" align="center">
					<template slot-scope="scope">
						<el-button type="primary" @click="editFunc(scope)" size="mini">编辑</el-button>
						<el-button type="warning" @click="deleteFunc(scope)" size="mini">删除</el-button>
					</template>
				</el-table-column>
				
			  </el-table>
			  
			  <div  style="flex-grow: 1; display: flex; flex-direction: row; justify-content: flex-end; margin: 10px 10px 10px 0;">
			  <el-pagination
			        @size-change="handleSizeChange"
			        @current-change="handleCurrentChange"
			        :current-page="currentPage"
			        :page-sizes="[10, 20, 50, 100]"
			        :page-size="limit"
			        layout="total, sizes, prev, pager, next, jumper"
			        :total="total">
			      </el-pagination>
			  </div>
		</div>
		
		<el-dialog title="新增" :visible.sync="dialogVisible" v-if="dialogVisible" width="700px" :before-close="handleClose">
		  <addUser></addUser>
		</el-dialog>
		
		<el-dialog title="编辑" :visible.sync="dialogVisible1" v-if="dialogVisible1" width="700px" :before-close="handleClose">
		  <editUser :ruleForm="editInfo"></editUser>
		</el-dialog>
		
	</div> 
</template>

<script>
	import addUser from './addUser.vue';
	import editUser from './editUser.vue';
	
	export default {
		components:{
			addUser, editUser
		},
		computed:{
		},
		data(){
			return {
				dialogVisible1:false,
				dialogVisible:false,
				loading:false,
				currentPage:1,
				tableData: [],
				total:0,
				limit:10,
				editInfo:{}
			}
		},
		created() {
			this.getData();
		},
		methods:{
			deleteApi(scope){
				let _this = this;
				_this.loading = true;
				_this.$api.post("/Set/deleteService", {id:scope.row.id}).then(res=>{
					_this.loading = false;
					if(res.code == 200){
						_this.tableData.splice(scope.$index, 1);
						_this.$message({ message: '删除成功', type: 'success', });
					}else{
						_this.$message({ message: '删除失败', type: 'warning', });
					}
				}).catch(res=>{
					_this.loading = false;
				});
			},
			deleteFunc(scope){
				let _this = this;
				this.$confirm('是否确认删除此客服?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					_this.deleteApi(scope);
				}).catch(() => {      
				});
			},
			editFunc(scope){
				this.editInfo = scope.row;
				this.dialogVisible1 = true;
			},
			download(scope){
				const url = this.$http_host + scope.row.grf_url;
				const link = document.createElement('a');
				
				link.href = url;
				link.download = scope.row.grf_url.split('\\')[1];
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			},
			addFunc(){
				this.dialogVisible = true;
			},
			handleClose(){
				this.dialogVisible = false;
				this.dialogVisible1 = false;
			},
			getData(){
				let that = this;
				that.loading = true;
				that.$api.post("/Set/getServiceList", {page:this.currentPage, limit:this.limit}).then(res=>{
					that.loading = false;
					that.tableData = res.data.list;
					that.total = res.data.total;
				}).catch(res=>{
					that.loading = false;
				});
			},
			handleSizeChange(e){
				this.limit = e;
				this.getData();
			},
			handleCurrentChange(e){
				this.currentPage = e;
				this.getData();
			}
		}
	}
</script>

